// https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore?tab=readme-ov-file#_unionby
type UnionFunction<T> = (value: T) => string | number;

export function unionBy<T>(...arrays: (T[] | UnionFunction<T>)[]): T[] {
  const iteratee = arrays.pop() as UnionFunction<T>;

  if (Array.isArray(iteratee)) {
    return [];
  }

  return [...arrays]
    .reverse()
    .flat()
    .filter(
      (
        (set) => (o) =>
          set.has(iteratee(o as T)) ? false : set.add(iteratee(o as T))
      )(new Set())
    ) as T[];
}

export function scalarArraysAreEqual<T extends string | number>(
  array1: T[],
  array2: T[]
): boolean {
  if (array1.length !== array2.length) return false;
  const a1 = [...array1].sort();
  const a2 = [...array2].sort();
  return a1.every((value, index) => value === a2[index]);
}
